var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: { "is-modified": _vm.value !== null, label: _vm.label, half: "" },
    },
    [
      _c(
        "select",
        {
          staticClass: "boss-input-select",
          domProps: { value: _vm.valueToId },
          on: {
            change: function ($event) {
              return _vm.update($event.target.value)
            },
          },
        },
        [
          _c("option", { domProps: { value: null } }, [
            _vm._v("\n      指定なし\n    "),
          ]),
          _vm._v(" "),
          _vm._l(_vm.options, function (option, i) {
            return _c("option", { key: i, domProps: { value: option.id } }, [
              _vm._v("\n      " + _vm._s(option.name) + "\n    "),
            ])
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }